var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDarkBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3534,
    cy: 21.5996,
    rx: 12.3534,
    ry: 12.4004,
    fill: "url(#paint0_linear_25_10618)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.906,
    cy: 19.6154,
    rx: 1.97654,
    ry: 1.98406,
    fill: "#FEFEFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6357,
    cy: 13.4153,
    rx: 1.23534,
    ry: 1.24004,
    fill: "#FEFEFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5771,
    cy: 17.8796,
    rx: 1.72948,
    ry: 1.73606,
    fill: "#FEFEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4917 9.51353C26.1211 10.6457 24.7188 12.5734 24.3452 12.9469C23.9715 13.3204 22.4668 11.3993 21.9019 10.4721C21.3369 9.54486 20.9981 6.6729 21.5937 5.25892C22.1894 3.84494 23.5734 1.86083 23.8403 2.18355C27.1866 4.67063 26.8624 8.38133 26.4917 9.51353Z",
    fill: "url(#paint1_linear_25_10618)",
    stroke: "#0D111C",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4625 14.6492C28.7846 14.9487 25.4107 14.4634 24.6887 14.2376C23.9667 14.0119 25.3833 10.7497 26.1752 9.38333C26.9671 8.017 30.3658 5.6062 32.5503 5.40343C34.7347 5.20067 38.1675 5.62377 37.9391 6.19009C37.0425 12.2184 32.1404 14.3496 30.4625 14.6492Z",
    fill: "url(#paint2_linear_25_10618)",
    stroke: "#0D111C",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_10618",
    x1: 0.931658,
    y1: 17.1614,
    x2: 15.1754,
    y2: 42.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F725A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_10618",
    x1: 23.5856,
    y1: 2,
    x2: 18.5811,
    y2: 9.12006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#729C3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_10618",
    x1: 38,
    y1: 5.73511,
    x2: 25.6489,
    y2: 4.22433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#729C3D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkBg);
export default __webpack_public_path__ + "static/media/logoDarkBg.e48044033b39bcb82e704aabbb023e8b.svg";
export { ForwardRef as ReactComponent };